<template>
  <div class="holder" :class="{ [type]: true }">
    <div class="quantity">
      <button
        :disabled="local_quantity - 5 < 0"
        @click.stop.prevent="decrement(5)"
        class="action decrement"
      >
        -5
      </button>
      <button
        :disabled="local_quantity - 2 < 0"
        @click.stop.prevent="decrement(2)"
        class="action decrement"
      >
        -2
      </button>
      <button
        :disabled="local_quantity - 1 < 0"
        @click.stop.prevent="decrement(1)"
        class="action decrement"
      >
        -1
      </button>
      <input
        @click.stop.prevent
        type="number"
        v-model="local_quantity"
        @change="updateQuantity"
      />
      <button @click.stop.prevent="increment(1)" class="action increment">
        +1
      </button>
      <button @click.stop.prevent="increment(2)" class="action increment">
        +2
      </button>
      <button @click.stop.prevent="increment(5)" class="action increment">
        +5
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      default: "embed",
    },
    quantity: {
      default: 0,
    },
  },
  data() {
    return {
      local_quantity: Number(this.quantity) || 0,
    };
  },
  methods: {
    increment(a) {
      this.local_quantity += a;
      this.$emit("Changed", this.local_quantity);
    },
    decrement(a) {
      if (this.local_quantity > 0) {
        this.local_quantity -= a;
        if (this.local_quantity < 0) this.local_quantity = 0;
        this.$emit("Changed", this.local_quantity);
      }
    },
    updateQuantity(e) {
      this.local_quantity = Number(e.target.value);
      this.$emit("Changed", e.target.value);
    },
  },
  watch: {
    quantity(new_quantity) {
      this.local_quantity = Number(new_quantity);
    },
  },
};
</script>

<style lang="scss" scoped>
.holder {
  display: inline-block;
  &.embed {
  }
  &.popup {
    position: absolute;
    right: -160px;
    background: #f1f5fd;
    padding: 2px 10px;
    top: -3px;
    border-radius: 6px;
    /* box-shadow: 6px 0px 10px rgb(0 0 0 / 10%); */
    border-radius: 0px 5px 5px 0px;
    border: 1px solid #dcdfe6;
    border-left: unset;
  }
  input {
    width: 30px;
    text-align: center;
    -moz-appearance: textfield;
    outline: none;
    border: unset;
    font-weight: bold;
    background: unset;
    &::-webkit-inner-spin-button,
    &::-webkit-outer-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
  }
  .action {
    position: relative;
    top: -1px;
    padding: 0px 4px;
    border: unset;
    background: unset;
    font-size: 10px;
    cursor: pointer;
    opacity: 0.7;
    outline: unset;
    &.decrement {
      &:hover {
        opacity: 1;
        color: red;
      }
    }
    &.increment {
      &:hover {
        opacity: 1;
        color: green;
      }
    }
    &[disabled] {
      color: black !important;
      opacity: 0.1 !important;
      cursor: default;
    }
  }
}
</style>

<style lang="scss" scoped>
@media (prefers-color-scheme: dark) {
  .holder.popup {
    background: #000;
    border-color: #585858;
    .action {
      color: white;
      &.increment:hover {
        color: #0aeb0a !important;
      }
      &.decrement:hover {
        color: #ff1100 !important;
      }
      &:disabled {
        color: white !important;
        opacity: 0.3 !important;
      }
    }
    input {
      color: white;
    }
  }
}
</style>
